export const SPREADSHEET_MIN_DIMENSION: [number, number] = [26, 60];
